import { render, staticRenderFns } from "./GuestDocumentationTrafalgar.vue?vue&type=template&id=5f353c02&scoped=true&"
import script from "./GuestDocumentationTrafalgar.vue?vue&type=script&lang=js&"
export * from "./GuestDocumentationTrafalgar.vue?vue&type=script&lang=js&"
import style0 from "./GuestDocumentationTrafalgar.vue?vue&type=style&index=0&id=5f353c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f353c02",
  null
  
)

export default component.exports